export default __webpack_public_path__ + "static/media/arrow-back.5efb85c5.svg";